guid = 0



export default -> guid += 1